import Home from '../views/Home.vue'
import overview from "../views/doctor/overview"
import inventory from "../views/doctor/inventory"
import inbound from "../views/doctor/inbound"
import offer from "../views/doctor/offer"
import outbound from "../views/doctor/outbound"
import payments from "../views/doctor/payments"
import storageFee from "../views/doctor/storageFee"
import settings from "../views/doctor/settings"
import teams from "../views/doctor/teams"
import warehouse from "../views/doctor/warehouse"
import account from "../views/public/account"
import amazon from "../views/public/amazon"
import bank from "../views/public/bank"
import password from "../views/public/password"
import mixedPackageClaim from "../views/mixedPackageClaim"

let doctorRoutes = [
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-home',
        leaf: true,//只有一个节点
        children: [
            {path: '/overview', component: overview, name: 'Home'}
        ]
    },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-file-text-o',
        leaf: true,//只有一个节点
        children: [
            {path: '/offer', component: offer, name: 'Offers'}
        ]
    }, {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-inbox',
        leaf: true,//只有一个节点
        children: [
            {path: '/inbound', component: inbound, name: 'Inbound'}
        ]
    }, {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-product-hunt',
        leaf: true,//只有一个节点
        children: [
            {path: '/inventory', component: inventory, name: 'Inventory'}
        ]
    }, {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-outdent',
        leaf: true,//只有一个节点
        children: [
            {path: '/outbound', component: outbound, name: 'Outbound'}
        ]
    }, {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-usd',
        leaf: true,//只有一个节点
        children: [
            {path: '/storageFee', component: storageFee, name: 'Storage Fee'}
        ]
    }, {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-credit-card',
        leaf: true,//只有一个节点
        children: [
            {path: '/payments', component: payments, name: 'Payments'}
        ]
    }, {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-university',
        leaf: true,//只有一个节点
        children: [
            {path: '/warehouse', component: warehouse, name: 'Warehouse'}
        ]
    }, {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-users',
        leaf: true,//只有一个节点
        children: [
            {path: '/teams', component: teams, name: 'Teams'}
        ]
    }, 
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-cubes',
        leaf: true,
        children: [
            {path: '/mixedPackageClaim', component: mixedPackageClaim, name: 'Mixed Claim'}
        ]
    }, 
    {
        path: '/',
        component: Home,
        name: 'Settings',
        iconCls: 'fa fa-cog',
        children: [
            {path: '/account', iconCls: 'fa fa-user', component: account, name: 'Account'},
            // {path: '/amazon', iconCls: 'fa fa-amazon', component: amazon, name: 'Amazon'},
            {path: '/password',iconCls: 'fa fa-key', component: password, name: 'Password'}
        ]
    }];

export default doctorRoutes;





// WEBPACK FOOTER //
// ./src/router/doctorRouter.js